import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { timeout } from '../../../helpers';
import { CmxLayoutService } from '../../../services/cmx-layout.service';
import { LegalEntityService } from '../../../services/legal-entity.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'cmx-legal-entity-listing',
  templateUrl: './cmx-legal-entity-listing.component.html',
  styleUrls: ['./cmx-legal-entity-listing.component.scss'],
})
export class CmxLegalEntityListingComponent implements OnInit, OnDestroy {
  @Input()
  public entityName: string = null;
  @Input()
  public entityId: string = null;
  @Input()
  public employeeVariant = false;

  public isMobile: boolean;
  public isRtl: boolean;
  public scrollCallback: () => Promise<boolean>;
  public isCollapsed: boolean;
  public version: number;
  public modalOpened = false;
  public searchTerm = '';
  public searchInput = '';
  public minCharachterInput = 4;
  public tmpEntityList: ILegalEntity[];

  private subscriptions: Subscription[] = [];

  constructor(
    public legalEntity: LegalEntityService,
    public layout: CmxLayoutService,
  ) {}

  ngOnInit() {
    this.scrollCallback = this.onScroll.bind(this);
    this.subscriptions.push(
      this.layout.isMobile.subscribe((value) => (this.isMobile = value)),
      this.layout.direction.subscribe((value) => (value === 'rtl' ? (this.isRtl = true) : (this.isRtl = false))),
      this.layout.isCollapsed.subscribe((value) => (this.isCollapsed = value)),
      this.layout.version.subscribe((value) => (this.version = value)),
      this.legalEntity.legalEntityActive
        .pipe(
          filter((data) => {
            if (data) {
              return !!Object.keys(data).length;
            }
            return false;
          }),
        )
        .subscribe((entityActive) => {
          if (this.employeeVariant) {
            this.entityName = entityActive.legalEntityDesc;
            this.entityId = entityActive.legalEntityTypeCode;
          }
        }),
    );

    // For testing employee variant pourpose
    // this.legalEntity.isLoading.next(false)
    // this.legalEntity.legalEntitiesList.pipe(take(1)).subscribe(data => this.tmpEntityList = data);
    // this.legalEntity.legalEntitiesList.next([])
    // const legalEntity = {
    //   legalEntityId: 362205,
    //   legalEntityTypeCode: "0050156806",
    //   legalEntityDesc: " ELEKTRO-SDRUŽENÍ spol. s r.o.",
    // }
    // this.legalEntity.legalEntityActive.next(legalEntity);
  }

  public async onScroll() {
    this.legalEntity.legalEntityReachedEnd.emit();
    await timeout(200);
    return true;
  }

  public onSearchTermChange(event: Event) {
    const cleanString = event.target['value'].replace(/[^\w\s\-]/g, '');
    event.target['value'] = cleanString;
    this.legalEntity.searchTermChange.emit(cleanString);
    this.searchTerm = cleanString;
  }

  ngOnDestroy() {
    this.subscriptions.map((sub) => sub.unsubscribe());
  }

  /**
   * @description - This function is used to emit the legal entity id clicked
   * @param e - Event with Legal Entity object
   */
  public setLegalEntityByComponent(e) {
    const entityData = e.detail;
    this.legalEntity.legalEntityChange.emit(entityData.entityId);
  }

  onModalShow(show) {
    this.modalOpened = show.detail;
    this.legalEntity.isModalOpen.emit(show.detail);
  }

  onSearchChange(event) {
    if (this.employeeVariant) {
      if (event.detail.length < this.minCharachterInput) {
        this.legalEntity.legalEntitiesList.next([]);
        this.legalEntity.isLoading.next(false);
      } else if (event.detail.length >= this.minCharachterInput) {
        this.legalEntity.isLoading.next(true);
      }
      this.searchInput = event.detail;
      const cleanString = event.detail.replace(/[^\w\s\-]/g, '');
      this.legalEntity.searchTermChange.emit(cleanString);
      this.searchTerm = cleanString;
    }
  }
}

export interface ILegalEntity {
  legalEntityDesc: string;
  legalEntityId: number;
  legalEntityTypeCode: string;
}
